/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'close-text': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd"><g transform="translate(12 12)" _stroke="#7A7F7E" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.1"><path pid="0" d="M0 9l9-9"/><path pid="1" d="M9 9L0 0"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/close-text.js